import { construirApiErroApresentavel } from '@/utils/ApiErroPadraoUtils';

const objectFromStream = async (stream: Blob | ArrayBuffer): Promise<IMensagemErro> => {
    const blob = stream instanceof ArrayBuffer ? new Blob([stream], { type: 'text/plain' }) : stream;
    const conteudoTexto = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
        reader.onerror = () => resolve('');
        reader.readAsText(blob);
    });

    if (conteudoTexto.indexOf('{') > -1) {
        try {
            return JSON.parse(conteudoTexto);
        } catch (_e) {
            return { mensagem: conteudoTexto || '' };
        }
    }

    return { mensagem: conteudoTexto || '' };
};

const toMensagemErro = (conteudo: string | ArrayBuffer): IMensagemErro => {
    return (typeof conteudo === 'string' ? { mensagem: conteudo } : { mensagem: null });
};

export interface IMensagemErro {
    mensagem: string;
    variante?: 'warning' | 'error';
}

interface IErrorHandler {

    unauthorized(data: any);

    erroTratado(error: any, resposta: IMensagemErro);
}

class ErrorHandling {

    private readonly data: string | ArrayBuffer | Blob;
    private readonly status: number;

    constructor(private error: any) {
        this.data = error.response ? error.response.data : error.toString();
        this.status = error?.response?.status || error?.status;
    }

    async tratarRespostaErro(callbacks: IErrorHandler) {
        const apiErroPadrao = construirApiErroApresentavel(this.error);
        if (apiErroPadrao) {
            callbacks.erroTratado(this.error, {
                mensagem: apiErroPadrao.mensagem,
                variante: apiErroPadrao.variante
            });
            return;
        }

        const apiErroPadraoData = construirApiErroApresentavel(this.data);
        if (apiErroPadraoData) {
            callbacks.erroTratado(this.error, {
                mensagem: apiErroPadraoData.mensagem,
                variante: apiErroPadraoData.variante
            });
            return;
        }

        if (this.error.response && (this.status === 403 || this.status === 401)) {
            callbacks.unauthorized(this.error.response.data);
        } else if (this.data && this.data instanceof ArrayBuffer || this.data instanceof Blob) {
            const respostaObj = await objectFromStream(this.data);
            const apiErroPadraoStream = construirApiErroApresentavel(respostaObj);
            if (apiErroPadraoStream) {
                callbacks.erroTratado(this.error, {
                    mensagem: apiErroPadraoStream.mensagem,
                    variante: apiErroPadraoStream.variante
                });
                return;
            }
            respostaObj.mensagem = `Erro ao efetuar download. ${respostaObj.mensagem}`;
            callbacks.erroTratado(this.error, respostaObj);
        } else if (this.error.response && this.status === 500) {
            const result = this.data instanceof Blob ? await objectFromStream(this.data) : toMensagemErro(this.data);
            callbacks.erroTratado(this.error, result);
        } else if (this.error.config && this.error.config.url.includes('/recuperaId') && this.error.response.data.mensagem && this.error.response.data.mensagem.includes('Voto não encontrado.')) {
            //FIXME: arrumar no frontend para não retornar 404 ao não encontrar o voto.. retornar 200 com mensagem de erro
            // console.error(error.response.data);
            return;
        } else if (this.error.config && this.error.config.url.includes('assinatura/tokenOtp') && this.error.response.data.mensagem && this.error.response.data.mensagem.includes('Código de autoriza')) {
            throw new Error('Código de autorização inválido');
            return;
        } else if (this.error.response && (this.error.response.data?.mensagem || this.error.response.data?.mensagens)) {
            const mensagem = this.error.response.data.mensagem ? this.error.response.data.mensagem : this.error.response.data.mensagens;
            callbacks.erroTratado(this.error, { mensagem: mensagem });
        } else if (this.error.message && this.error.message.toLowerCase().indexOf('network error') > -1) {
            callbacks.erroTratado(this.error, { mensagem: 'Ocorreu um erro: ' + this.error });
        } else {
            callbacks.erroTratado(this.error, { mensagem: null });
        }
    }
}

const defaultErrorHandler = (callbacks: IErrorHandler) => (error: any) => {
    new ErrorHandling(error).tratarRespostaErro(callbacks);
};

export default defaultErrorHandler;
